export default function AppPromo() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-primary-100/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 max-w-4xl mx-auto">
          <div className="flex-shrink-0">
            <div className="relative w-48 h-48 md:w-56 md:h-56 rounded-3xl overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.08)]">
              <img
                src="https://readdy.ai/api/search-image?query=Manga%20reading%20app%20on%20smartphone%20mockup%20showing%20vibrant%20comic%20page%20with%20action%20scene%2C%20clean%20modern%20UI%2C%20warm%20orange%20and%20coral%20theme%2C%20Korean%20webtoon%20style%2C%20minimal%20phone%20design%2C%20cream%20background&width=560&height=560&seq=app-promo-01&orientation=squarish"
                alt="番茄漫画App界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              随时随地，畅快追漫
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              番茄漫画移动端提供更流畅的下拉式阅读体验，离线缓存、夜间模式、追更提醒一应俱全。
              支持 iOS 和 Android，数据实时同步，换设备也能无缝续看。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-300 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
            <p className="mt-3 text-xs text-foreground-400">也可直接访问移动网页版，无需下载即可阅读</p>
          </div>
        </div>
      </div>
    </section>
  );
}